import {createReducer} from 'redux-act';
import {
  CLEAR_CUSTOMER_INSIGHTS,
  GET_CUSTOMER_INSIGHTS_ERROR,
  GET_CUSTOMER_INSIGHTS_SUCCESS,
  SET_CUSTOMER_INSIGHTS_LOADING
} from './action';

const initialState = () => ({
  data: null,
  loading: false,
  error: null
});

const customerInsightsReducer = createReducer(
  {
    [GET_CUSTOMER_INSIGHTS_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload || null,
      error: null
    }),
    [GET_CUSTOMER_INSIGHTS_ERROR]: (state, payload) => ({
      ...state,
      error: payload || null
    }),
    [SET_CUSTOMER_INSIGHTS_LOADING]: (state, payload) => ({
      ...state,
      loading: payload
    }),
    [CLEAR_CUSTOMER_INSIGHTS]: () => ({
      ...initialState()
    })
  },
  initialState()
);

export default customerInsightsReducer;
